<div >
  <div fxLayout="row" fxLayout.lt-md="column" class="right">
    <button mat-icon-button class="view-remito-buttons" *ngIf="showReprocessButton"
            [disabled]="isNoRecordSelected || isProcessing" (click)="reprocessMultipleOtdsFiles()">
      <mat-icon *ngIf="!isReprocessProcessing">autorenew</mat-icon>
      <mat-spinner *ngIf="isReprocessProcessing" class="loading-spinner-small" diameter="15"></mat-spinner>
    </button>
    <button mat-icon-button class="view-remito-buttons" *ngIf="showArchiveButton"
            [disabled]="isNoRecordSelected || isProcessing" (click)="archiveMultipleRecords()">
      <mat-icon *ngIf="!isArchiveProcessing">delete</mat-icon>
      <mat-spinner *ngIf="isArchiveProcessing" class="loading-spinner-small" diameter="15"></mat-spinner>
    </button>

    <!-- ***** Download Excel file button ***** -->
    <button mat-icon-button class="view-remito-buttons" (click)="print()">
      <mat-icon *ngIf="!isDownloadingExcel">description</mat-icon>
      <mat-spinner *ngIf="isDownloadingExcel" class="loading-spinner-small" diameter="15"></mat-spinner>
    </button>

  </div>
  <fab-loading-spinner *ngIf="isLoading"></fab-loading-spinner>
  <div dynamicGrid [tableContainerElement]="tableContainer" [selector]="selector" #tableContainer
       fxLayout="column" class="table-height">
    <table mat-table [dataSource]="dataSource" matSort matSortActive="fecProceso" matSortDirection="desc" matSortDisableClear (matSortChange)="onSortChange()" #dataTable>

      <!-- Row Checkbox -->
      <ng-container matColumnDef="checkbox">
        <th mat-header-cell *matHeaderCellDef scope="col">
          <mat-checkbox [checked]="isCheckAll" [disabled]="true" (click)="clickCheckAll()"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element" class="center">
          <mat-checkbox class="otds-error-checkbox" [(ngModel)]="element.isChecked" [matBadgeColor]="element.canBeReprocessed ? 'primary' : 'warn'" [matBadge]="isRecordSelected ? getIsReprocessableColumnLabel(element) : null"></mat-checkbox>
        </td>
      </ng-container>

      <!-- File Name Column -->
      <ng-container matColumnDef="nombreDeArchivo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre de Archivo
          <rem-string-filter #tableFilter columnDef="nombreDeArchivo" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-width-med-decription">
           <span>
                {{element.nombreDeArchivo}}
           </span>
        </td>
      </ng-container>

      <!-- line number -->
      <ng-container matColumnDef="lineNum">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Line No.
          <rem-string-filter #tableFilter columnDef="lineNum" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="cell-width-xstext" *matCellDef="let element">
          {{element.lineNum}}
        </td>
      </ng-container>

      <!-- VIN -->
      <ng-container matColumnDef="vin">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> VIN
          <rem-string-filter #tableFilter columnDef="vin" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="cell-width-lgtext" *matCellDef="let element">
          {{element.vin}}
        </td>
      </ng-container>

      <!-- nro remito -->
      <ng-container matColumnDef="nroRemito">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nro Remito
          <rem-string-filter #tableFilter columnDef="nroRemito" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="cell-width-mtext" *matCellDef="let element">
          {{element.nroRemito}}
        </td>
      </ng-container>

      <!-- origen -->
      <ng-container matColumnDef="origen">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Origen
          <rem-string-filter #tableFilter columnDef="origen" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="cell-width-mtext" *matCellDef="let element">
          {{element.origen}}
        </td>
      </ng-container>

      <!-- codDestino -->
      <ng-container matColumnDef="codDestino">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Destino
          <rem-string-filter #tableFilter columnDef="codDestino" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="cell-width-mtext" *matCellDef="let element">
          {{element.codDestino}}
        </td>
      </ng-container>

      <!-- transporte Column -->
      <ng-container matColumnDef="transporte">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Transporte
          <rem-string-filter #tableFilter columnDef="transporte" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="cell-width-mtext" *matCellDef="let element">
          {{ element.transporte }}
        </td>
      </ng-container>

      <!-- Tpre error Column -->
      <ng-container matColumnDef="tpreError">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> TPRE
          <rem-string-filter #tableFilter columnDef="tpreError" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="cell-width-mtext" *matCellDef="let element">
          {{element.tpreError}}
        </td>
      </ng-container>

      <!-- misc error Column -->
      <ng-container matColumnDef="error">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Misc Error
          <rem-string-filter #tableFilter columnDef="error" [operators]="operators" (filterChange)="filterChange($event);"></rem-string-filter>
        </th>
        <td mat-cell  class="cell-width-description" *matCellDef="let element">
          {{element.error}}
        </td>
      </ng-container>

      <!-- Fec Proceso Column -->
      <ng-container matColumnDef="fecProceso">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fec Proceso
          <rem-date-filter #tableFilter columnDef="fecProceso" [operators]="dateOperators" (filterChange)="filterChange($event);"></rem-date-filter>
        </th>
        <td mat-cell  class="cell-width-mtext" *matCellDef="let element"> {{element.fecProceso | customDate}} </td>
      </ng-container>

      <!-- Reprocess Button Column -->
      <ng-container matColumnDef="reprocessButtons">
        <th mat-header-cell *matHeaderCellDef scope="col"></th>
        <td mat-cell *matCellDef="let element"  class="left" nowrap="true">
          <button mat-icon-button class="view-remito-buttons" *ngIf="showReprocessButton"
                  [disabled]="isRecordSelected || !element.canBeReprocessed || isProcessing" (click)="reprocessSingleOtdsFile(element)">
            <mat-icon *ngIf="!element.isReprocessProcessing">autorenew</mat-icon>
            <mat-spinner *ngIf="element.isReprocessProcessing" class="loading-spinner-small" diameter="15"></mat-spinner>
          </button>
          <button mat-icon-button class="view-remito-buttons" *ngIf="showReprocessButton"
                  [disabled]="isRecordSelected || isProcessing" (click)="showRowDataEditingDialog(element)">
            <mat-icon>search</mat-icon>
          </button>
          <button mat-icon-button class="view-remito-buttons" *ngIf="showArchiveButton"
                  [disabled]="isRecordSelected || isProcessing" (click)="archiveSingleRecord(element)">
            <mat-icon *ngIf="!element.isArchiveProcessing">delete</mat-icon>
            <mat-spinner *ngIf="element.isArchiveProcessing" class="loading-spinner-small" diameter="15"></mat-spinner>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator
                 [pageSize]="pageSizes[0]"
                 [pageSizeOptions]="pageSizes"
                 [length]="totalElements"
                 (page)="updatePageState()">
  </mat-paginator>
</div>

